module.exports = __webpack_public_path__ + "img/Monoceros.9db2f398.png";